import { useCallback, useContext, useEffect, useState } from "react";
import CustomTable from "../../../components/CustomTable";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { toast } from "react-toastify";
import { formatDate } from "../../../../../utils/DateFormat";
import { ticketService } from "../../../../../services/api/ticketService";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Loading from "../../../components/Loading";

const columns = [
  {
    key: "id",
    title: "STT",
    minWidth: "20px",
    align: "text-left",
    render: (value) => <div className="pl-2">{value}</div>,
  },
  { key: "date", title: "Ngày", minWidth: "120px" },
  {
    key: "content",
    title: "Nội dung",
    minWidth: "600px",
    render: (value) => <div className="min-w-[600px]">{value}</div>,
  },
  {
    key: "status",
    title: "Trạng thái",
    align: "text-center",
    minWidth: "150px",
    render: (value) => (
      <div className="flex items-center justify-center">
        <div
          className={`w-[120px] text-sm py-1 ${value.color} text-white text-center rounded-xl`}
        >
          {value.label}
        </div>
      </div>
    ),
  },
];

const TabTicketInfo = () => {
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const currentPage = Number(searchParams.get("page")) || 1;

  const fetchTickets = useCallback(
    async (customer_id = id, page = currentPage, limit = itemsPerPage) => {
      try {
        setLoading(true);
        const response = await ticketService.get_all(
          customer_id,
          page,
          limit,
          token
        );

        const formattedData = response.data.ticketCustomer.map(
          (ticket, index) => ({
            id: itemsPerPage * (page - 1) + index + 1,
            date: formatDate(ticket.createdAt) || "N/A",
            content: ticket.message || "No content",
            status:
              ticket.status === "pending"
                ? { label: "Chờ phản hồi", color: "bg-orange-500" }
                : { label: "Đã hoàn thiện", color: "bg-green-500" },
            nav_id: ticket._id,
          })
        );
        setData(formattedData);
        setTotalPages(response.data.totalPages || 1);
      } catch (error) {
        toast.dismiss();
        toast.error(
          error.response?.data?.message ||
            "Không thể kết nối tới server. Vui lòng kiểm tra mạng."
        );
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    },
    [id, token, currentPage, itemsPerPage]
  );

  useEffect(() => {
    fetchTickets();
  }, [fetchTickets]);

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center mt-10">
        <Loading />
      </div>
    );
  }

  return (
    <CustomTable
      data={data}
      columns={columns}
      currentPage={currentPage}
      setCurrentPage={(page) => {
        const params = new URLSearchParams(searchParams);
        params.set("page", page.toString());
        setSearchParams(params);
      }}
      totalPages={totalPages}
      itemsPerPage={itemsPerPage}
      setItemsPerPage={setItemsPerPage}
      onRowClick={(item) => {
        navigate(`/quan-ly-khach-hang/ticket/${item.nav_id}`);
      }}
      setView={true}
      setEdit={true}
      basePath="/quan-ly-khach-hang/ticket"
    />
  );
};

export default TabTicketInfo;
